import React, { useEffect, useLayoutEffect } from "react";
import { Animated } from "react-native";
import { withRouter } from "react-router-dom";
import Circle from "../../views/IndexView";
import { moduleid } from "../../Utils/static-strings";
import { styles } from "./styles/index";
import { useState, useRef } from "react";

const Index = (props) => {
  const [check, setCheck] = useState(1);
  const [animate, setAnimate] = useState(false);
  const [descale, setDescale] = useState(true);
  const scaleValue = useState(new Animated.Value(1))[0];
  const descaleValue = useState(new Animated.Value(500))[0];
  const [moduleName, setModuleName] = useState(null);

  useLayoutEffect(() => {
    if (props.riskCalculation !== "") {
      setDescale(true);
    } else {
      setDescale(false);
    }
  }, []);

  const startAnimation = () => {
    setAnimate(true);
    Animated.timing(scaleValue, {
      toValue: 500,
      duration: 600,
    }).start();
  };

  const startDescale = () => {
    setDescale(true);
    Animated.timing(descaleValue, {
      toValue: 1,
      duration: 900,
    }).start(() => setDescale(false));
  };

  const handleBgColor = () => {
    switch (moduleName) {
      case moduleid.loss():
        return "var(--game-background-color-la)";
      case moduleid.experience():
        return "var(--game-background-color-exp)";
      case moduleid.future():
        return "var(--game-background-color-pb)";
      case moduleid.risk():
        return "var(--game-background-color-atr)";
      case moduleid.knowledge():
        return "var(--game-background-color-obj)";
      default:
        return "#eee";
    }
  };

  return (
    <div
      style={{
        display: "flex",
        height: "100%",
        width: "100%",
        position: "absolute",
        flexDirection: "column",
        justifyContent: "space-between",
        backgroundColor: "var(--mandg-alt-background)",
      }}
    >
      {/* <Header currentRoute={"Understanding"} /> */}
      {descale && (
        <Animated.View
          style={[
            styles.animatedCircleStyle,
            {
              backgroundColor: handleBgColor(),
              transform: [{ scale: descaleValue }],
            },
          ]}
        />
      )}
      {animate && (
        <Animated.View
          style={[
            styles.animatedCircleStyle,
            {
              backgroundColor: handleBgColor(),
              transform: [{ scale: scaleValue }],
            },
          ]}
        />
      )}
      <Circle
        {...props}
        {...{ check }}
        {...{ setCheck }}
        {...{ startAnimation }}
        {...{ setModuleName }}
        {...{ startDescale }}
      />
    </div>
  );
};

export default withRouter(Index);
